<template>
  <page-content
    title="Meja 2: Faktor Penyakit Tidak Menular"
    :with-margin="false"
  >
    <vue-tabs>
      <v-tab title="Riwayat PTM">
        <div class="mx-3">
          <v-select
            placeholder="Pasien yang diperiksa"
            label="fullname"
            :options="patients"
            v-model="patient"
          />
          <br />
          <b>Riwayat PTM pada Keluarga</b>
          <div class="divider"></div>
          <c-input-radio label="Penyakit Diabetes" inline>
            <c-input-radio-item
              v-model="formFamilyHistory.diabetes"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formFamilyHistory.diabetes"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Hipertensi" inline>
            <c-input-radio-item
              v-model="formFamilyHistory.hypertention"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formFamilyHistory.hypertention"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Jantung" inline>
            <c-input-radio-item
              v-model="formFamilyHistory.cardiac"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formFamilyHistory.cardiac"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Stoke" inline>
            <c-input-radio-item
              v-model="formFamilyHistory.stroke"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formFamilyHistory.stroke"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Asma" inline>
            <c-input-radio-item
              v-model="formFamilyHistory.asthma"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formFamilyHistory.asthma"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Kanker" inline>
            <c-input-radio-item
              v-model="formFamilyHistory.cancer"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formFamilyHistory.cancer"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Kolesterol Tinggi" inline>
            <c-input-radio-item
              v-model="formFamilyHistory.cholesterol"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formFamilyHistory.cholesterol"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <br />
          <b>Riwayat PTM pada Diri Sendiri</b>
          <div class="divider"></div>
          <c-input-radio label="Penyakit Diabetes" inline>
            <c-input-radio-item
              v-model="formSelfHistory.diabetes"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formSelfHistory.diabetes"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Hipertensi" inline>
            <c-input-radio-item
              v-model="formSelfHistory.hypertention"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formSelfHistory.hypertention"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Jantung" inline>
            <c-input-radio-item
              v-model="formSelfHistory.cardiac"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formSelfHistory.cardiac"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Stoke" inline>
            <c-input-radio-item
              v-model="formSelfHistory.stroke"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formSelfHistory.stroke"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Asma" inline>
            <c-input-radio-item
              v-model="formSelfHistory.asthma"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formSelfHistory.asthma"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Penyakit Kanker" inline>
            <c-input-radio-item
              v-model="formSelfHistory.cancer"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formSelfHistory.cancer"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Kolesterol Tinggi" inline>
            <c-input-radio-item
              v-model="formSelfHistory.cholesterol"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formSelfHistory.cholesterol"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>

          <button
            class="btn btn-primary btn-block"
            @click="doSubmitDiseasesHistory"
            v-if="!isLoading"
          >
            Simpan
          </button>
          <p align="center" v-else>
            <pulse-loader
              :loading="isLoading"
              size="10px"
              :color="colorPrimary"
            />
          </p>
        </div>
      </v-tab>
      <v-tab title="Faktor Risiko Perilaku">
        <div class="mx-3">
          <c-input-date id="date" label="Tanggal Periksa">
            <datetime
              type="date"
              format="dd/LL/yyyy"
              value-zone="local"
              v-model="formBehavioralFactor.date"
            />
          </c-input-date>
          <v-select
            placeholder="Pasien yang diperiksa"
            label="fullname"
            :options="patients"
            v-model="patient"
          />
          <br />
          <c-input-radio label="Merokok" inline>
            <c-input-radio-item
              v-model="formBehavioralFactor.smoking"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formBehavioralFactor.smoking"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Makan Sayur dan Buah < 5 porsi sehari" inline>
            <c-input-radio-item
              v-model="formBehavioralFactor.lackVegetableAndFruit"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formBehavioralFactor.lackVegetableAndFruit"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Kurang Aktivitas Fisik" inline>
            <c-input-radio-item
              v-model="formBehavioralFactor.lackOfPhysicalActivity"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formBehavioralFactor.lackOfPhysicalActivity"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>
          <c-input-radio label="Konsumsi Minuman Beralkohol" inline>
            <c-input-radio-item
              v-model="formBehavioralFactor.alcohol"
              c-value="1"
              text="Ya"
            />
            <c-input-radio-item
              v-model="formBehavioralFactor.alcohol"
              c-value="0"
              text="Tidak"
            />
          </c-input-radio>

          <button
            class="btn btn-primary btn-block"
            @click="doSubmitBehavioralFactor"
            v-if="!isLoading"
          >
            Simpan
          </button>
          <p align="center" v-else>
            <pulse-loader
              :loading="isLoading"
              size="10px"
              :color="colorPrimary"
            />
          </p>
        </div>
      </v-tab>
    </vue-tabs>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "diseases-factors",
  data: function () {
    return {
      patient: "",
      isLoading: false,
    };
  },
  watch: {
    patient: {
      immediate: true,
      handler: function (value) {
        if (!this.isEmpty(value)) {
          const userId = value.id;
          const date = LuxonDateTime.fromISO(
            this.formBehavioralFactor.date
          ).toFormat("yyyy-LL-dd");
          this.$store.dispatch("getDiseasesHistory", userId);
          this.$store.dispatch("getCheckup", { userId, date });
        }
      },
    },
    "formBehavioralFactor.date": function (newValue) {
      if (!this.isEmpty(this.patient)) {
        const userId = this.patient.id;
        const date = LuxonDateTime.fromISO(newValue).toFormat("yyyy-LL-dd");
        this.$store.dispatch("getCheckup", { userId, date });
      }
    },
  },
  computed: {
    ...mapGetters({
      patients: "patients",
      formSelfHistory: "selfHistory",
      formFamilyHistory: "familyHistory",
      formBehavioralFactor: "checkup",
    }),
  },
  methods: {
    doSubmitBehavioralFactor: function () {
      if (this.isEmpty(this.patient)) {
        this.$toasted.error("Gagal! Harap pilih pasien.");
        return;
      }

      this.isLoading = true;
      const userId = this.patient.id;
      const payload = this.formBehavioralFactor;

      this.$store
        .dispatch("createOrUpdateCheckup", { userId, payload })
        .then(() => {
          this.isLoading = false;
          this.$toasted.success("Berhasil disimpan.");
        })
        .catch(() => {
          this.isLoading = false;
          this.$toasted.error("Gagal! Tidak dapat menyimpan.");
        });
    },
    doSubmitDiseasesHistory: function () {
      if (this.isEmpty(this.patient)) {
        this.$toasted.error("Gagal! Harap pilih pasien.");
        return;
      }

      this.isLoading = true;
      const userId = this.patient.id;
      const selfHistory = this.formSelfHistory;
      const familyHistory = this.formFamilyHistory;

      this.$store
        .dispatch("updateDiseasesHistory", {
          userId,
          selfHistory,
          familyHistory,
        })
        .then(() => {
          this.isLoading = false;
          this.$toasted.success("Berhasil disimpan.");
        })
        .catch(() => {
          this.isLoading = false;
          this.$toasted.error("Gagal! Terjadi kesalahan.");
        });
    },
  },
  created: function () {
    this.$store.dispatch("startPageLoading");
    this.$store
      .dispatch("getAllUser", "patient")
      .then(() => {
        this.$store.dispatch("stopPageLoading");
      })
      .catch(() => {
        this.$store.dispatch("stopPageLoading");
      });
  },
};
</script>
